export const GETALL_ROLE_REQUEST = "GETALL_ROLE_REQUEST";
export const GETALL_ROLE_SUCCESS = "GETALL_ROLE_SUCCESS";
export const GETALL_ROLE_FAIL = "GETALL_ROLE_FAIL";

export const GETDETAIL_ROLE_REQUEST = "GETDETAIL_ROLE_REQUEST";
export const GETDETAIL_ROLE_SUCCESS = "GETDETAIL_ROLE_SUCCESS";
export const GETDETAIL_ROLE_FAIL = "GETDETAIL_ROLE_FAIL";